import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiHelper } from 'cad/common/services/api/api-helper';

@Injectable()
export class PrimaryContactApi {

  private readonly endpoint: string = 'associate/business-associate/';
  private readonly suffix: string = '/primary-contact';

  constructor(
    private apiHelper: ApiHelper,
  ) {}

  public findAll = (baId: string | number, effFrom: any, effTo: any): Observable<any> => {
    let data: any = {};
    if (effFrom) {
      data.effBeginDt = effFrom;
    }
    if (effTo) {
      data.effEndDt = effTo;
    }
    return this.apiHelper.request(this.endpoint + baId + this.suffix + '/filter', { body: data });
  }

}
